import { BulletinMediaItem } from "@/components/alerts/add-v2/model/types";

/**
 * Whether the lightbox has anything to show for a file.
 *
 * Only images and videos: `MediaDropZone` accepts nothing else, so a bulletin can only hold something
 * else if it was uploaded through the old flow. Such a file keeps its card, its delete button and its
 * entity picker — it just has no full-size view, and `MediaRow` renders no expand button for it.
 *
 * Its own module rather than living in `MediaLightbox.tsx`, so that file exports a component and
 * nothing else — the directory's naming rule, and what keeps fast refresh working.
 */
export const isViewable = (item: BulletinMediaItem): boolean =>
  item.contentType.startsWith("image/") ||
  item.contentType.startsWith("video/");
